import { rem } from "polished";
import React from "react";
import styled, { css } from "styled-components";
import Button, { ButtonWrapper } from "../../Button";
import Modal from "../../Modal";
import { useDispatch, useSelector } from "react-redux";
import makePayload from "./make-payload";
import { addToCart } from "../../../lib/redux/slices/cart-slice";
import { Spinner } from "../../Spinner";

const AddToCart = ({ stage }) => {
  const [open, onSetModal] = React.useState(false);
  const [previewImage, setPreviewImage] = React.useState("");

  const data = useSelector((s) => s);
  const cartData = useSelector((s) => s.cart);
  const { loading } = cartData;
  const dispatch = useDispatch();

  const setPreview = () => {
    setTimeout(() => {
      if (stage && stage.current) {
        const dataURL = stage.current.toDataURL({
          format: 'jpeg',
          // height: 500,
          quality: 0.5,
          pixelRatio: 2,
          crossOrigin: "anonymous",
        });

        setPreviewImage(dataURL);
      }
    }, 1000);
  };

  
  const handleContinue = async () => {
    const payload = makePayload(data, true, previewImage);
    const { payload: responsePayload } = await dispatch(addToCart(payload));
    window.location.href = responsePayload.redirect_url;
  };

  return (
    <>
      <CartButton>
        <ButtonWrapper>
          <Button
            onClick={() => {
              onSetModal(!open);
              setPreview();
            }}
          >
            lägg i varukorg
          </Button>
        </ButtonWrapper>
      </CartButton>

      <Modal
        wrapperId={`modal`}
        isOpen={open}
        overlayClick
        handleClose={() => {
          onSetModal(false);
          setPreviewImage("");
        }}
        styles={{
          maxWidth: "60%",
          maxHeight: "90%",
          height: "100%",
          width: "100%",
        }}
        parentStyles={{
          zIndex: 9999,
        }} 
        
        modelContainerStyles={{
          // overflow: 'hidden',
        }}
        title={""}
        className='center-block builder-preview'
      >
        <ModalContent>
          {loading === "pending" ? (
            <Spinner
              hasContainer
              strokeWidth={10}
              width={50}
              className="centerAlign"
            />
          ) : null}
          <div className="content-block">
           
            <h4>Grattis!</h4>
            <h2>Du har nu designat din bänkskiva.</h2>
            <p>Är du nöjd så fortsätt till webshopen och din ritning sparas.</p>
             {previewImage && (
              <div className="preview-image">
                <img src={previewImage} alt="preview" />
              </div>
            )}
          </div>
          <div className="buttons">
           
            <Button className="continue" onClick={handleContinue}>
              Fortsätt
            </Button>
             <Button
              skin="red"
              onClick={() => {
                onSetModal(false);
                setPreviewImage("");
              }}
            >
              Avbryt
            </Button>
          </div>
        </ModalContent>
      </Modal>
    </>
  );
};
export default AddToCart;

const CartButton = styled.div`
  ${({ theme }) => css`
    padding: ${rem(10)};
  `}
`;

const ModalContent = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    /* justify-content: center; */
    flex-direction: column;
    height: 100%;
    padding: ${rem(30)} 0;

    .content-block {
      text-align: center;
      margin-bottom: ${rem(30)};
      /* overflow: hidden auto; */

      h2 {
        font-size: 26px;
      }

      h2,
      h4,
      p {
        margin-bottom: 10px;
        font-weight: normal;
      }

      .preview-image {
        margin: 20px 0;

        img {
          max-width: 60%;
          /* margin-left: 20%; */
        }
      }
    }
    .buttons {
      display: inline-block;
      margin: 0 -7px;
      position: sticky;
      bottom: 0;

      .builder-button {
        display: inline-block;
        padding: 0 7px;

        button {
         min-width: 200px;
        }
      }
    }
  `}
`;
